import { DesignData } from '../types';

// A multipage design is "flat" when every spread holds a single page (e.g. a
// brochure). Spread books (photobooks) have a single-page cover followed by
// 2-page inside spreads, so at least one spread holds more than one page.
function isFlatDesign(design: DesignData): boolean {
  return !design.spreads.some((spread) => spread.pages.length > 1);
}

export default isFlatDesign;
